module.exports = __webpack_public_path__ + "05_short_gray.716586c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_short_gray.png
// module id = 5EGr
// module chunks = 0